import styled from 'styled-components';

export const Container = styled.div`
  min-width: 6.4rem;
`;
